<div class="d-flex row">
  <div class="col-6">
    <img class="login-img" src="./assets/login-image/login-img.jpg">
  </div>
  <div class="login-card col-6">
    <img class="logo-img" src="./assets/login-image/logo-img.png">
    <div class="login-title">AssisThemis</div>
    <div class="">Controle seus processos de qualquer lugar</div>

    <form class="login-form-card" [formGroup]="form">
      <div class="login-form-item">
        <label for="login-email" class="login-form">Email</label>
        <input
          id="login-email"
          type="email"
          class="form-control login-input"
          placeholder="E-mail"
          formControlName="email">
      </div>
      <div class="login-form-item">
        <label for="login-pwd" class="login-form">Senha</label>
        <input
          id="login-pwd"
          type="password"
          class="form-control login-input"
          placeholder="Senha"
          formControlName="password">
      </div>
      <div class="login-button-card">
        <button class="btn btn-primary btn-sm btn-block login-button" (click)="autenticar()"
                [disabled]="loading$|async">
          <div *ngIf="loading$|async" class="loading-spinner-btn spinner-grow"></div>
          <div *ngIf="!(loading$|async)">Entrar</div>
        </button>
      </div>
    </form>
  </div>
</div>
